<template>
    <section>
        <div class="container">
            <h2 class="pb-2">{{ titulo != null ? titulo : this.title != null ? this.title : '' }}</h2>
            <div v-if="!items" class="row row-cols-1 g-4"
                v-bind:class="[columnas > 0 ? 'row-cols-md-' + columnas : 'row-cols-md-3']">
                <div class="col" v-for="n in (parseInt(columnas) > 0 ? parseInt(columnas) : 3)" v-bind:key="n">
                    <div class="card loading-card {{n}}">
                        <div class="card-body rounded d-flex align-items-center">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row row-cols-1 g-4" v-bind:class="[columnas > 0 ? 'row-cols-md-' + columnas : 'row-cols-md-3']">
                <div class="col" v-for="( el, i ) in items" :key="i">
                    <div class="card relative card-pophover">
                        <div class="card-body rounded d-flex align-items-center card-pophover__body">
                            <div
                                class="icon-square d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 icon-container">
                                <svg v-if="el.icon.includes('ptn')" class="ptn-i-2x text-ptn-color-gsj-2"
                                    v-bind:class="[el.desc ? 'ptn-i-3x' : '']">
                                    <use v-bind="{ 'xlink:href': '#' + el.icon }"></use>
                                </svg>
                                <span v-if="!el.icon.includes('ptn')"
                                    class="material-symbols-outlined text-ptn-color-gsj-2 ptn-i-2x"
                                    v-bind:class="[el.desc ? 'ptn-i-3x' : '']">{{ el.icon }}</span>
                            </div>
                            <div class="title-card">
                                <div class="" v-bind:class="[el.desc ? 'h4' : 'h5']">
                                    <a v-if="el.url" v-bind:href="el.url" v-bind:target="el.target ? el.target : '_self'"
                                        class="stretched-link link-secondary text-ptn-color-gsj-5">{{ el.title }}</a>
                                    <span v-else class="cursor-pointer">{{ el.title }}</span>
                                </div>
                                <p class="card-text" v-if="el.desc">{{ el.desc }}</p>
                            </div>
                        </div>
                        <div v-if="el.links" class="pophover">
                            <div class="pophover-links" v-for="( el, i ) in el.links" :key="i">
                                <a v-bind:href="el.url ? el.url : '#'" v-bind:target="el.target ? el.target : '_target'">
                                    {{ el.title }}
                                    <img src="../../assets/iconos/pdf_image.png" alt="pdf-image">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>


<script>
const axios = require('axios');
export default {
    name: 'IconTitleCardComponent',
    props: {
        titulo: String,
        subtitulo: String,
        columnas: String,
        filtros: Object,
        data: Object
    },
    data() {
        return {
            hash: "ITCGC",
            items: null,
            title: null,
            desc: null
        }
    },
    mounted() {
        if (this.data == null) {
            let params = {};
            if (this.filtros != null && this.filtros != "") {
                params = this.filtros;
            }
            params.tipo = this.hash;
            axios.post(process.env.VUE_APP_API_URL, params)
                .then(response => {
                    this.items = response.data ? response.data.items : null
                    this.title = response.data ? response.data.title : null
                    this.desc = response.data ? response.data.desc : null
                    localStorage.setItem(this.hash, JSON.stringify(response));
                })
                .catch(error => {
                    if (!error.response) {
                        console.log("Fuera de Linea");
                        if (localStorage.getItem(this.hash)) {
                            console.log("Cargando elementos de cache para " + this.hash);
                            var resp = JSON.parse(localStorage.getItem(this.hash));
                            this.items = resp.data ? resp.data.items : null
                            this.title = resp.data ? resp.data.title : null
                            this.desc = resp.data ? resp.data.desc : null
                        }
                    }
                })
        } else {
            this.items = this.data;
        }
    }
}
</script>

<style scoped>
.cursor-pointer{
    cursor: pointer;
}
.card-pophover__body{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 5px;
    align-items: start;
    text-align: center;
}
.title-card{
    display: flex;
}
.card-pophover {
    position: relative;
}

.pophover {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #F2F2F2;
    color: white;
    padding: 10px;
    opacity: 0;
    transform: translateY(-10px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    z-index: 100;
}

.pophover-links{
    margin-bottom: 10px;
    margin-left: 5px;
    margin-right: 5px;
    border-bottom: 1px solid #FF8200;
    color: black;
}

.pophover-links img{
    width: 25px;
}
.pophover-links a{
    display: flex;
    justify-content: space-between;
    color: black;
    padding: 3px 5px;
}
.pophover-links a:hover{
    text-decoration: none;
    background-color: #E1E1E1;
    transition: color 0.3s ease, background-color 0.3s ease;
}

.card-pophover:hover .pophover {
    opacity: 1;
    transform: translateY(0);
}
</style>